import create from "zustand";

const useNavigationStore = create((set, get) => ({
    mobileModalIsActive: false,
    path: null,
    activeSection: null,
    activeSubSectionItem: null,
    setMobileModalIsActive: (mobileModalIsActive) =>
        set({ mobileModalIsActive }),
    toggleMobileModal: () => {
        const { setMobileModalIsActive, mobileModalIsActive } = get();
        return setMobileModalIsActive(!mobileModalIsActive);
    },
    openMobileModal: () => get().setMobileModalIsActive(true),
    closeMobileModal: () => get().setMobileModalIsActive(false),

    setActive: (nav) => {
        const path = get().path;
        set({ activeSection: null, activeSubSectionItem: null });
        nav.sections.forEach((section) => {
            if (section.href && section.href === path) {
                set({ activeSection: section.name });
                return;
            }
            if (section.subsections && section.subsections.length > 0) {
                section.subsections.forEach((subsection) => {
                    subsection.items.forEach((item) => {
                        if (item.href === path) {
                            set({ activeSubSectionItem: item.text });
                            set({ activeSection: section.name });
                        }
                    });
                });
            }
        });
    },
    setPath: (rawPath, hash) => {
        if (hash) {
            set({ path: rawPath + hash });
        } else {
            set({ path: rawPath.replace(/\/$/, "") });
        }
    },
}));
export default useNavigationStore;
